<template>
  <div>
    <Header
      :show="true"
      title="加油申请使用说明书"
      left="prepage"
      :click-left="clickLeft"
    />
    <iframe
      style="width: 100%; height: calc(100vh - 46px - 65px); border: 0"
      src="https://vw.copoiot.com/manual.html#/apply"
    />
    <Footer value="service" />
  </div>
</template>
<script>
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {};
  },
  methods: {
    clickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>
